// App main
const main = async () => {
  // Async load the Vue 3 APIs we need from the Vue ESM
  const { default: Vue } = await import(/* webpackChunkName: "vue" */ "vue");
  const { default: PortalVue } = await import(/* webpackChunkName: "vue" */ "portal-vue");
  Vue.use(PortalVue);

  const { createStore } = await import(/* webpackChunkName: "store" */ "./store/store.js");

  const store = await createStore(Vue);

  await store.dispatch("getSettings");
  await store.dispatch("getCart");
  await store.dispatch("getAddresses");
  await store.dispatch("getIdentity");

  // Create our vue instance
  const vm = new Vue({
    el: "#page-container",
    store,
    components: {
      "cart-drawer": () => import(/* webpackChunkName: "cart-drawer" */ "../vue/CartDrawer.vue"),
      "cart": () => import(/* webpackChunkName: "cart" */ "../vue/Cart.vue"),
      "cart-summary": () => import(/* webpackChunkName: "cart" */ "../vue/CartSummary.vue"),
      "cart-discount-code": () => import(/* webpackChunkName: "cart" */ "../vue/CartDiscountCode.vue"),
      "mobile-menu": () => import(/* webpackChunkName: "mobile-menu" */ "../vue/MobileMenu.vue"),
      "quick-search": () => import(/* webpackChunkName: "quick-search" */ "../vue/QuickSearch.vue"),
      "product-images": () => import(/* webpackChunkName: "product-images" */ "../vue/ProductImages.vue"),
      "quick-add-to-cart": () => import(/* webpackChunkName: "quick-add-to-cart" */ "../vue/QuickAddToCart.vue"),
      "add-to-cart": () => import(/* webpackChunkName: "add-to-cart" */ "../vue/AddToCart.vue"),
      "toggle": () => import(/* webpackChunkName: "toggle" */ "../vue/Toggle.vue"),
      "notification": () => import(/* webpackChunkName: "notification" */ "../vue/Notification.vue"),
      "product-filters": () => import(/* webpackChunkName: "product-filters" */ "../vue/ProductFilters.vue"),
      "currency-selector": () => import(/* webpackChunkName: "currency-selector" */ "../vue/CurrencySelector.vue"),
    },
    data: () => ({}),
    methods: {},
    mounted() {},
  });

  return vm;
};

// Execute async function
main().then((vm) => {

  /**
   * Self invoking global scrips
   */
  import(/* webpackChunkName: "glide" */ "./components/glide.js");
  import(/* webpackChunkName: "utils" */ "./components/in-view.js");


});
